// extracted by mini-css-extract-plugin
export var avatarContainer = "_78-0";
export var avatarTypingWave = "_78-i";
export var gray = "_78-f";
export var green = "_78-c";
export var icon = "_78-9";
export var image = "_78-1";
export var lg = "_78-6";
export var md = "_78-5";
export var presenceDot = "_78-b";
export var red = "_78-d";
export var sm = "_78-4";
export var status = "_78-a";
export var typingDot = "_78-h";
export var typingPill = "_78-g";
export var xl = "_78-7";
export var xs = "_78-3";
export var xxl = "_78-8";
export var xxs = "_78-2";
export var yellow = "_78-e";